var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncidentLocationIconPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 115314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4148",
    d: "M0 1.52588e-05H22.737V24.308H0V1.52588e-05Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59738_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4143",
    d: "M18.025 11.246C18.025 16.574 10.032 24.308 10.032 24.308C10.032 24.308 2.039 16.575 2.039 11.246C2.039 9.12611 2.88112 7.09306 4.3801 5.59409C5.87907 4.09511 7.91214 3.25299 10.032 3.25299C12.1519 3.25299 14.1849 4.09511 15.6839 5.59409C17.1829 7.09306 18.025 9.12611 18.025 11.246Z",
    fill: "url(#paint0_linear_1_2261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4144",
    d: "M14.716 11.195C14.716 12.4367 14.2227 13.6276 13.3447 14.5057C12.4666 15.3837 11.2757 15.877 10.034 15.877C9.41915 15.877 8.81033 15.7559 8.24228 15.5206C7.67423 15.2853 7.15809 14.9404 6.72333 14.5057C6.28856 14.0709 5.94367 13.5548 5.70837 12.9867C5.47308 12.4187 5.35199 11.8098 5.35199 11.195C5.35199 10.5801 5.47308 9.97131 5.70837 9.40326C5.94367 8.83521 6.28856 8.31907 6.72333 7.88431C7.15809 7.44954 7.67423 7.10468 8.24228 6.86938C8.81033 6.63409 9.41915 6.51299 10.034 6.51299C11.2757 6.51299 12.4666 7.00626 13.3447 7.88431C14.2227 8.76235 14.716 9.95325 14.716 11.195Z",
    fill: "url(#paint1_linear_1_2261)",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4145",
    d: "M21.222 6.40599C21.222 7.86468 20.6425 9.26362 19.6111 10.2951C18.5796 11.3265 17.1807 11.906 15.722 11.906C14.2633 11.906 12.8644 11.3265 11.8329 10.2951C10.8015 9.26362 10.222 7.86468 10.222 6.40599C10.222 4.9473 10.8015 3.54836 11.8329 2.51691C12.8644 1.48546 14.2633 0.905991 15.722 0.905991C17.1807 0.905991 18.5796 1.48546 19.6111 2.51691C20.6425 3.54836 21.222 4.9473 21.222 6.40599Z",
    fill: "url(#paint2_linear_1_2261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4146",
    d: "M21.222 6.40599C21.222 7.86468 20.6425 9.26362 19.6111 10.2951C18.5796 11.3265 17.1807 11.906 15.722 11.906C14.2633 11.906 12.8644 11.3265 11.8329 10.2951C10.8015 9.26362 10.222 7.86468 10.222 6.40599C10.222 4.9473 10.8015 3.54836 11.8329 2.51691C12.8644 1.48546 14.2633 0.905991 15.722 0.905991C17.1807 0.905991 18.5796 1.48546 19.6111 2.51691C20.6425 3.54836 21.222 4.9473 21.222 6.40599Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4147",
    d: "M13.048 6.40599H18.394",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2261",
    x1: 10.032,
    y1: 3.25299,
    x2: 10.032,
    y2: 24.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2261",
    x1: 10.034,
    y1: 6.51299,
    x2: 10.034,
    y2: 15.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2261",
    x1: 15.722,
    y1: 0.905991,
    x2: 15.722,
    y2: 11.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentLocationIconPrimary);
export default __webpack_public_path__ + "static/media/incident-location-icon-primary.f698f1deb89cbd8c87749b1bed0f1a16.svg";
export { ForwardRef as ReactComponent };